module.exports = __webpack_public_path__ + "static/media/hank_intro.837d0bbc.svg";